<div>
  <div>
    <a href="#"
       (click)="$event.preventDefault(); handleSelectMore()"
       class="select-more-items-link"
    >
      {{ selectedOptions.length ? selectMoreMessage : selectMessage }}
    </a>
  </div>
  <div>
    <div *ngIf="selectedOptions.length === 0">
      <span class="empty-message">No selection yet</span>
    </div>
    <div *ngFor="let option of selectedOptions" class="option-container">
      <div class="option-content">
        <div>{{ option.text }}</div>
<!--        <div *ngIf="option.originalData" class="description">{{ option.originalData.description }}</div>-->
      </div>
      <div
        class="option-delete-icon"
        (click)="handleUnselectOption(option.value)"
      >
      </div>
    </div>
  </div>
  <div class="py-3 error-message" *ngIf="touched && selectionLimitErrorMessage">
    {{ selectionLimitErrorMessage }}
  </div>
</div>
